module.exports = __webpack_public_path__ + "static/img/品牌logo3@2x.043ae1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/品牌logo3@2x.png
// module id = UL3C
// module chunks = 192